import { render, staticRenderFns } from "./Form02.vue?vue&type=template&id=5c38a025&scoped=true&"
import script from "./Form02.vue?vue&type=script&lang=js&"
export * from "./Form02.vue?vue&type=script&lang=js&"
import style0 from "./Form02.vue?vue&type=style&index=0&id=5c38a025&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c38a025",
  null
  
)

export default component.exports